/**
 * Main 페이지 팀별 Config
 *
 * 팀마다 다른 값만 정의
 * - externalLinks: 외부 링크 (구매 URL 등)
 * - notificationRoutes: 알림 라우팅
 */

import type { TeamSlug } from '@/app/(football)/[team]/_context/types';
import type { MainPageConfig } from '@/app/(football)/[team]/main/_context/types';

import { bluewingsConfig } from './bluewings';
import { dhcfcConfig } from './dhcfc';
import { fcanyangConfig } from './fcanyang';
import { fcseoulConfig } from './fcseoul';
import { jbfcConfig } from './jbfc';
import { steelersConfig } from './steelers';
import { uhdfcConfig } from './uhdfc';

export const mainPageConfig: Record<TeamSlug, MainPageConfig> = {
  fcseoul: fcseoulConfig,
  bluewings: bluewingsConfig,
  steelers: steelersConfig,
  fcanyang: fcanyangConfig,
  uhdfc: uhdfcConfig,
  dhcfc: dhcfcConfig,
  jbfc: jbfcConfig,
};
